export const excelHeaderCellsRange = [
  'A1',
  'B1',
  'C1',
  'D1',
  'E1',
  'F1',
  'G1',
  'H1',
  'I1',
  'J1',
  'K1',
  'L1',
  'M1',
  'N1',
  'O1',
  'P1',
  'Q1',
  'R1',
  'S1',
  'T1',
  'U1',
  'V1',
  'W1',
  'X1',
  'Y1',
  'Z1',
  'AA1',
  'AB1',
  'AC1',
  'AD1',
  'AE1',
  'AF1',
  'AG1',
  'AH1',
  'AI1',
  'AJ1',
  'AK1',
  'AL1',
  'AM1',
  'AN1',
  'AO1',
  'AP1',
  'AQ1',
  'AR1',
  'AS1',
  'AT1',
  'AU1',
  'AV1',
  'AW1',
  'AX1',
  'AY1',
  'AZ1',
];
